import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;

export const Content = styled.div`
    /* width:100%; */
    flex-grow:1;
    display:flex;
    flex-direction: column;
    overflow-y: scroll;
    font-size: var(--fontSmall);
    padding-bottom: 30px;
        
`;

export const Info = styled.div`
    font-size: 1rem;
    padding-top: 10px;
    .div_btn {
        display: inline-block;
        padding:2px 10px;
        margin: 8px 10px;
        border-radius: 3px;
        background-color: var(--morienGreen);
        border: 1px solid var(--morienGreen);
        color: var(--white);
        text-decoration: none;
    }   
    .btn {
        padding:2px 13px;
        background-color: var(--morienGreen);
        border: 1px solid var(--morienGreen);
        border-radius: 3px;
        color: var(--white);
        text-decoration: none;
        font-size:var(--fontNormal);
        font-weight:400;
    }
   
`;

export const Line = styled.div`
    padding-left: 10px;
    padding-right: 10px;
`

export const MLabel = styled.label`
    padding: 0 5px;
    color: #6c757d;
    font-size: 0.9rem;
`